export class ExternalResumeRequestDTO {
  Connector: string;
  Code: string;
  RedirectURI: string;
  FileId: number;
  FileName: string;
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/upload-resume/external-resume-request.dto.ts